import axios from 'axios';

const V2_BASE_URL = '/api/v2';
const TOKEN_STORAGE_KEY = 'token';
const BEARER_PREFIX = 'Bearer ';

const v2Client = axios.create({ baseURL: V2_BASE_URL });

v2Client.interceptors.request.use((config) => {
  const token = axios.defaults.headers.common.Authorization || (BEARER_PREFIX + (localStorage.getItem(TOKEN_STORAGE_KEY) || ''));
  if (token) config.headers.Authorization = token;
  return config;
});

export default v2Client;
